/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useState } from "react";
import { Typography } from "@mui/material";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { isArrayNotEmpty, isStringNotEmpty, isTrue, isFalse } from "utils/empty-exists";
import AccordionSectionDisplay from "cms/components/components/accordion/display/section";

const AccordionComponentDisplay = () => {
    
    const ctx = useContext(ContentZoneContext);
    const { component } = ctx;
    const {
        title = "",
        description = "",
        sections = {},
        showSteps = false,
    } = component || {};
    const hasContent = isStringNotEmpty(title) || isStringNotEmpty(description) || isArrayNotEmpty(sections);
    const [expanded, setExpanded] = useState(false);

    const handleExpandChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Fragment>
            {isTrue(hasContent) &&
                <div key={Date.now()}>
                    <div style={{ marginBottom: "1em", paddingLeft: "0.8em" }}>
                        <Typography variant='h3' color='text.primary'>
                            {title}
                        </Typography>
                        <Typography variant='body1' color='text.primary'>
                            {description}
                        </Typography>
                    </div>

                    <div
                        className='simplicity-accordion panel-group accordion'
                        data-group-type='accordion'
                        role='tablist'
                        aria-multiselectable='true'
                    >
                        {sections &&
                            sections.map((section, index) => (
                                <AccordionSectionDisplay
                                    section={section}
                                    group_id={section.guid || index}
                                    key={section.guid}
                                    tabIndex={index}
                                    expanded={expanded}
                                    setExpanded={setExpanded}
                                    handleExpandChange={handleExpandChange}
                                    stepNumber={index + 1}
                                    showSteps={showSteps}
                                />
                            ))}
                    </div>
                </div>
            }
            {isFalse(hasContent) &&
                <EmptyContentMessage hasContent={hasContent} component={component} />
            }
        </Fragment>
    );
};

AccordionComponentDisplay.displayName = "AccordionComponentDisplay";
export { AccordionComponentDisplay };
